export default {"src":"/_next/static/media/Handy-Kebab.890b0fb9.svg","height":737,"width":709,"blurWidth":0,"blurHeight":0};